import axios from 'axios';
import { clearToken, getToken } from '../auth';
import { restHost } from '../utils';

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: restHost,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add Authorization header automatically
apiClient.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle 401 Unauthorized - redirect to login
    if (error.response?.status === 401) {
      clearToken();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default apiClient;

